import { component } from 'picoapp'
import { Splide } from '@splidejs/splide'

export default component((node) => {
  const slider = new Splide(node, {
    type: 'slide',
    pagination: false,
    arrows: true,
    gap: '0.75rem',
    drag: true,
    perPage: 1,
    speed: 400,
    easing: 'ease',
    mediaQuery: 'min',
    padding: {
      right: '4.625rem',
    },
    breakpoints: {
      768: {
        gap: '1rem',
        perPage: 2,
        padding: {
          right: '2rem',
        },
      },
      1024: {
        gap: '1rem',
        perPage: 3,
        padding: {
          right: '2rem',
        },
      },
    },
  })

  slider.mount()
})
